module.exports = __webpack_public_path__ + "static/media/banner_dragonTiger-half.713a02a2.png";